import { useLang } from "@/context/LanguageContext";

export const Marquee = ({ items }) => {
  const { isRtl } = useLang();
  // The second copy is purely visual filler for the scroll loop — hide it from
  // assistive tech so the phrases aren't announced twice.
  const doubled = [...items, ...items];
  return (
    <div
      className="relative w-full overflow-hidden border-y border-forest/10 bg-sage/60 py-6"
      data-testid="marquee"
    >
      <div className={`marquee-track ${isRtl ? "animate-marquee-rtl" : "animate-marquee"}`}>
        {doubled.map((item, idx) => (
          <span
            key={idx}
            aria-hidden={idx >= items.length ? "true" : undefined}
            className="mx-8 inline-flex items-center gap-8"
          >
            <span className="font-display text-xl sm:text-2xl font-bold text-forest/85 whitespace-nowrap">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-gold" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
};
